import {Component} from 'san';

import styles from './style/index.module.less';

export default class RelatedNews extends Component {
    static template = require('./index.html');
    initData() {
        return {
            styles,
        };
    }
    attached() {
        const show_list = this.data.get('data');
        const nid = this.data.get('nid');
        const isCeiling = this.data.get('isCeiling');
        const ceilingStatus = isCeiling ? 2 : 1;
        this.storeDispatch('relatedNews:showLog', {nid, show_list, ceilingStatus});
    }
    clickHandler(event, relateNews) {
        const nid = this.data.get('nid');
        const click_nid = `news_${relateNews.nid}`;
        const isCeiling = this.data.get('isCeiling');
        const ceilingStatus = isCeiling ? 2 : 1;
        this.storeDispatch('relatedNews:clkLog', {nid, click_nid, ceilingStatus});
    }
}
